define('apps/course-intro/templates/regions/materials/content',['handlebars'], function(Handlebars) {

return Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div class=\"materials-page-content\">\n    <h1 class=\"level-header\">A library of module materials all in one place.</h1>\n</div>\n<div class=\"empty-materials-page-content hide\">\n    <header>\n        <h1 class=\"main-title\">Materials.</h1>\n    </header>\n    <section class=\"grid-region\">\n        <p>Sorry! There are no materials available at this time.</p>\n    </section>\n</div>\n";
  })

});
